import React from "react";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12 px-6 md:px-16 font-sans">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 md:gap-16">
        {/* Logo and Description */}
        <div>
          <img
            src={logo}
            alt="Riff Raff Tech Solutions Logo"
            className="w-36 mb-4 filter brightness-0 invert"
          />
          <p className="text-gray-300 text-sm leading-relaxed">
            Empowering businesses through innovative digital solutions — where
            technology meets creativity and performance.
          </p>
        </div>

        {/* Company Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-white">Company</h3>
          <ul className="space-y-2 text-gray-400">
            <li>
              <Link to="/" className="hover:text-white transition">
                Home
              </Link>
            </li>
            <li>
              <Link to="/" className="hover:text-white transition">
                About
              </Link>
            </li>
            <li>
              <Link to="/" className="hover:text-white transition">
                Careers
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-white">Contact</h3>
          <div className="space-y-3 text-gray-400 text-sm">
            <div>
              <p className="font-medium text-white">Email:</p>
              <a
                href="mailto:riffrafftechsolutions@gmail.com"
                className="hover:text-white transition"
              >
                riffrafftechsolutions@gmail.com
              </a>
            </div>
            <div>
              <p className="font-medium text-white">Phone:</p>
              <a
                href="tel:+919952749721"
                className="hover:text-white transition"
              >
                +91 9952749721
              </a>
            </div>
          </div>
        </div>

        {/* Social Media Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-white">Follow Us</h3>
          <ul className="space-y-2 text-gray-400">
            <li className="flex items-center gap-2 hover:text-white transition">
              <FaInstagram />{" "}
              <a
                href="https://www.instagram.com/riffrafftechsolutions/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
            <li className="flex items-center gap-2 hover:text-white transition">
              <FaLinkedin />{" "}
              <a
                href="https://www.linkedin.com/company/riff-raff-tech-solutions/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-400 text-sm">
        © 2024 Riff Raff Tech Solutions. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
